import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import PurchasingReport from "../../../containers/modules/report/purchasing-report";

export default function PurchasingReportRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="purchasing-report"
      index
      element={
        <AccessControl
          name={"Invoice Report Show"}
          auth={authUser}
          component={() => <PurchasingReport />}
        />
      }
    ></Route>
  );
}
